import { render, staticRenderFns } from "./recent-marketing.vue?vue&type=template&id=71e1ed67&scoped=true&"
import script from "./recent-marketing.vue?vue&type=script&lang=js&"
export * from "./recent-marketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e1ed67",
  null
  
)

export default component.exports